<div class="dropdown">
   <ctp-button [style]="'secondary'"><span i18n>More&nbsp;</span><fa-icon [icon]="caretDown"></fa-icon></ctp-button>
   <div class="dropdown-content" >
      <p (click)="optionClicked(option.optionNum)" *ngFor="let option of options" >{{option.text}}</p>
   </div>
</div>
